import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import * as styles from '../../../config/styles'

const SingleSelect = (props) => {
    const options = props.options
    const value = props.value
    const placeholder = props.placeholder || 'Select...'
    const onChange = props.onChange
    const disabled = props.disabled
    const required = props.required

    // When searching, only search on label
    const customFilter = (option, searchText) => {
        if( option.label?.toLowerCase().includes(searchText.toLowerCase()) ) {
            return true
        }
        return false
    }

    // Custom format for options with extra text
    const formatOptionLabel = ({ label, extraText }, { context }) => {
        if (context === 'menu') {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <span>{label}</span>
                    {extraText && <small className="single-select-extratext">{extraText}</small>}
                </div>
            )
        }
        return label
    }

    return (
        <Select
            value={options.filter(option => option.value === value)}
            onChange={value => onChange(value) }
            options={options}
            placeholder={placeholder}
            isMulti={false}
            styles={styles.singleSelect}
            noOptionsMessage={() => 'No results found'}
            backspaceRemovesValue={false}
            isSearchable={true}
            filterOption={customFilter}
            isDisabled={disabled}
            required={required}
            formatOptionLabel={formatOptionLabel}
        />
    )
}

export default SingleSelect
